import { GLOBAL_LINKS_WEB_APP } from "../../pages/global/links";

// ============ Controle de estado do webapp
const L_STOR_UTILS_SITE_REF = 'L_STOR_UTILS_SITE_REF';
export const utils_site_ref_get = () => {
    return window.sessionStorage.getItem(L_STOR_UTILS_SITE_REF);
}
export const utils_site_ref_yes = () => {
    window.sessionStorage.setItem(L_STOR_UTILS_SITE_REF, 1);
}

export const utils_site_ref_launch_app = () => {
    window.sessionStorage.removeItem(L_STOR_UTILS_SITE_REF);
    setTimeout(() => {
        window.location.href = GLOBAL_LINKS_WEB_APP;
    }, 33);
}

/// ============ FIM